<app-header class="no-print"></app-header>
<ng-container>

  <div class="transfers" [class.support-active]="supportActive" [class.settings-active]="settingsActive">
    <app-animated-bg class="no-print"></app-animated-bg>

    <div *ngIf="!purchase._id && !purchaseId && purchaseTypeOptions && purchaseTypeOptions.length > 0" class="settings">

      <div *ngIf="!purchaseTypeKey" class="setting">
        <div class="label">Transfer Type</div>
        <div class="value">
          <select [ngModel]="purchase.type" (ngModelChange)="purchaseTypeChange($event)">
            <option *ngFor="let purchaseType of purchaseTypeOptions" [value]="purchaseType.key">{{purchaseType.name}}</option>
          </select>
        </div>
      </div>

      <div *ngIf="purchaseTypeKey" class="transfer-type-name">{{purchase.typeObject.name}}</div>

      <div *ngIf="showTransferName()" class="setting">
        <div class="label">Name</div>
        <div class="value"><input type="text" [(ngModel)]="purchase.name" /></div>
      </div>

      <ng-container *ngIf="purchase.typeObject">
        <!-- PurchaseType.customFields: transfer-level text fields (e.g. Invoice
             Number); a required one blocks Build until it is filled in. -->
        <div *ngFor="let field of customFields()" class="setting custom-field" [class.required-missing]="field.required && isBlank(purchase[field.key])">
          <div class="label">{{field.name}}</div>
          <div class="value"><input type="text" [(ngModel)]="purchase[field.key]" [attr.data-cy]="'custom-field-' + field.key" /></div>
          <div *ngIf="field.required && isBlank(purchase[field.key])" class="required-hint">{{field.name}} is required</div>
        </div>

        <!-- Source / target: with more than one choice nothing is preselected —
             the user must pick, so a forgotten dropdown can never silently
             land on the first store in the list. A single choice is taken. -->
        <div *ngIf="purchase.typeObject.sourceType" class="setting location-select" [class.required-missing]="!purchase.locationId">
          <div class="label">{{purchase.typeObject.sourceLabel}}</div>
          <div class="value">
            <select [ngModel]="purchase.locationId" (ngModelChange)="purchaseLocationChange($event)" data-cy="source-select">
              <option *ngIf="!purchase.locationId" [ngValue]="null" disabled>Select…</option>
              <option *ngFor="let location of purchase.locationOptions" [value]="location._id">{{location.name}}</option>
            </select>
          </div>
          <div *ngIf="!purchase.locationId && purchase.locationOptions?.length > 0" class="required-hint">{{purchase.typeObject.sourceLabel}} is required</div>
          <div *ngIf="purchase.locationOptions && purchase.locationOptions.length === 0" class="required-hint">No {{purchase.typeObject.sourceLabel | lowercase}} is available to you</div>
        </div>

        <div *ngIf="purchase.typeObject.targetType" class="setting location-select" [class.required-missing]="!purchase.customerId">
          <div class="label">{{purchase.typeObject.targetLabel}}</div>
          <div class="value">
            <select [ngModel]="purchase.customerId" (ngModelChange)="purchaseCustomerChange($event)" data-cy="target-select">
              <option *ngIf="!purchase.customerId" [ngValue]="null" disabled>Select…</option>
              <option *ngFor="let location of purchase.customerOptions" [value]="location._id">{{location.name}}</option>
            </select>
          </div>
          <div *ngIf="!purchase.customerId && purchase.customerOptions?.length > 0" class="required-hint">{{purchase.typeObject.targetLabel}} is required</div>
          <div *ngIf="purchase.customerOptions && purchase.customerOptions.length === 0" class="required-hint">No {{purchase.typeObject.targetLabel | lowercase}} is available to you</div>
        </div>

        <div *ngIf="purchase.typeObject.subtypes" class="setting">
          <div class="label">Subtype</div>
          <div class="value">
            <select [ngModel]="purchase.subtype" (ngModelChange)="purchaseSubtypeChange($event)">
              <option *ngFor="let subtype of purchase.typeObject.subtypes" [value]="subtype.key">{{subtype.name}}</option>
            </select>
          </div>
        </div>

        <div *ngIf="purchase.type == 'adjustment-retail' || purchase.typeObject.countAsOf" class="setting">
          <div class="label">Inventory Count Date/Time</div>
          <div class="value">
            <input type="text"
              ngxDaterangepickerMd
              [(ngModel)]="purchase.countDateTime"
              [timePicker]="true"
              [singleDatePicker]="true" />
          </div>
        </div>

        <div *ngIf="purchase.type == 'vendor-retail'" class="setting">
          <div class="label">Transfer Date</div>
          <div *ngIf="purchase.status == 'open'">
            <input type="text"
              ngxDaterangepickerMd
              [(ngModel)]="purchase.effectiveDate"
              [singleDatePicker]="true" />
          </div>
          <div *ngIf="purchase.status != 'open' && purchase.effectiveDate">
            {{purchase.effectiveDate.startDate | rf:'dateTime'}}
          </div>
        </div>

        <div *ngIf="purchase.note" class="setting">
          <div class="label">Notes</div>
          <div class="value"><textarea [(ngModel)]="purchase.note[0]"></textarea></div>
        </div>

        <!-- Build is always visible but stays disabled until every selection
             and required field is in place; the hints above say what is missing. -->
        <div class="setting">
          <div class="button-wrapper">
            <div class="button green" [class.disabled]="buildBlockers().length > 0" (click)="newPurchase()" data-cy="build-transfer">{{ purchase.typeObject?.buildLabel || 'Build Transfer' }}</div>
            <div *ngIf="sameSourceAndTarget()" class="required-hint">{{purchase.typeObject.sourceLabel}} and {{purchase.typeObject.targetLabel}} must be different locations</div>
          </div>
        </div>

        <div class="mobile-spacer"></div>

      </ng-container>
    </div>

    <ng-container *ngIf="purchase._id">
      <div class="transfers-header">
        <div class="headers" [class]="hasSteps() ? 'status-stepped' : 'status-'+purchase.status" [style.background]="currentStepColor()">
          <div class="clickable" (click)="startEditSettings()">
            <div class="key">{{purchase.key}}</div>
            <div *ngIf="showTransferName()" class="name">{{purchase.name}}</div>
            <div class="notes">{{purchase.notes}}</div>
          </div>
          <div class="purchase-detail">
            <div>
              <div class="label">Transfer Type</div>
              <div class="value">{{purchase.typeObject.name}}</div>
            </div>
            <div *ngIf="purchase.typeObject.sourceType">
              <div class="label">Source</div>
              <div class="value">{{purchase.locationName}}</div>
            </div>
            <div *ngIf="purchase.typeObject.targetType">
              <div class="label">Target</div>
              <div class="value">{{purchase.customerName}}</div>
            </div>
            <div *ngIf="purchase.typeObject.subtypes && purchase.subtype">
              <div class="label">Subtype</div>
              <div class="value">{{purchase.subtype}}</div>
            </div>
            <div *ngFor="let field of customFields()">
              <div class="label">{{field.name}}</div>
              <div class="value">{{purchase[field.key]}}</div>
            </div>
            <div *ngIf="purchase.type == 'adjustment-retail' || purchase.typeObject.countAsOf">
              <div class="label">Inventory Count Date/Time</div>
              <div class="value">
                <ng-container *ngIf="purchase.countDateTime">{{purchase.countDateTime | rf:'dateTime'}}</ng-container>
                <ng-container *ngIf="!purchase.countDateTime">{{purchase.timeAdded | rf:'dateTime'}}</ng-container>
              </div>
            </div>
            <div *ngIf="purchase.type == 'vendor-retail'">
              <div class="label">Transfer Date</div>
              <div *ngIf="purchase.status == 'open'" class="value">
                <input type="text"
                  ngxDaterangepickerMd
                  [(ngModel)]="purchase.effectiveDate"
                  [singleDatePicker]="true" />
              </div>
              <div *ngIf="purchase.status != 'open' && purchase.effectiveDate" class="value">
                {{purchase.effectiveDate.startDate | rf:'dateTime'}}
              </div>
            </div>
          </div>
          <div class="purchase-summary">
            <div *ngIf="purchase.typeObject.sourceType">Source: {{purchase.locationName}}</div>
            <div *ngIf="purchase.typeObject.targetType">Target: {{purchase.customerName}}</div>
          </div>
          <!-- Download is always available: the built-in CSV of the on-screen
               grid, plus any export reports configured for the type. -->
          <!-- Local Inventory Cache: one dot for connection + sync + queue state; tap for details.
               Outside .export so phones (where export is hidden) show it too. -->
          <div *ngIf="inventoryCacheService.isEnabled()" class="sync-dot-button no-print" [title]="syncDotTitle()" (click)="toggleSyncSheet(); $event.stopPropagation()">
            <div class="sync-dot" [ngClass]="syncDotState()" [class.pulse]="syncDotState() === 'yellow'"></div>
            <div *ngIf="queueStatus && queueStatus.pending > 0" class="sync-count">{{queueStatus.pending}}</div>
          </div>
          <div class="export no-print">
            <div class="export-button refresh" [class.spinning]="refreshing" title="Check for updates" (click)="refreshUpdates($event)">
              <svg width="100%" height="100%" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17.65 6.35A7.96 7.96 0 0 0 12 4a8 8 0 1 0 7.75 10h-2.08A6 6 0 1 1 12 6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg>
            </div>
            <div class="export-button download" title="Download" (click)="download()">
              <svg width="100%" height="100%" viewBox="0 0 20 19" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" xmlns:serif="http://www.serif.com/" style="fill-rule:evenodd;clip-rule:evenodd;stroke-linejoin:round;stroke-miterlimit:1.41421;"><path d="M19.416,9.032c-0.318,0 -0.572,0.255 -0.572,0.573l0,5.209c0,1.417 -1.155,2.567 -2.567,2.567l-12.565,0c-1.417,0 -2.567,-1.154 -2.567,-2.567l0,-5.294c0,-0.318 -0.254,-0.572 -0.573,-0.572c-0.317,0 -0.572,0.254 -0.572,0.572l0,5.294c0,2.049 1.667,3.712 3.712,3.712l12.565,0c2.049,0 3.712,-1.667 3.712,-3.712l0,-5.209c0,-0.314 -0.255,-0.573 -0.573,-0.573" style="fill-rule:nonzero;"/><path d="M9.592,13.978c0.11,0.11 0.259,0.17 0.402,0.17c0.145,0 0.293,-0.055 0.404,-0.17l3.639,-3.64c0.225,-0.224 0.225,-0.585 0,-0.809c-0.224,-0.225 -0.585,-0.225 -0.809,0l-2.66,2.664l0,-11.619c0,-0.319 -0.255,-0.574 -0.574,-0.574c-0.317,0 -0.572,0.255 -0.572,0.574l0,11.619l-2.664,-2.664c-0.225,-0.225 -0.585,-0.225 -0.811,0c-0.224,0.224 -0.224,0.585 0,0.809l3.645,3.64Z" style="fill-rule:nonzero;"/></svg>
            </div>
            <div *ngIf="purchase.printOptions && purchase.printOptions.length" class="export-button print" title="Print" (click)="print()">
              <svg width="100%" height="100%" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M448 1536h896v-256h-896v256zm0-640h896v-384h-160q-40 0-68-28t-28-68v-160h-640v640zm1152 64q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zm128 0v416q0 13-9.5 22.5t-22.5 9.5h-224v160q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-160h-224q-13 0-22.5-9.5t-9.5-22.5v-416q0-79 56.5-135.5t135.5-56.5h64v-544q0-40 28-68t68-28h672q40 0 88 20t76 48l152 152q28 28 48 76t20 88v256h64q79 0 135.5 56.5t56.5 135.5z"/></svg>
            </div>
          </div>
          <div class="transfer-options" (click)="transferControlsLaunch()">
            <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g stroke-width="0"></g><g stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M8 12C9.10457 12 10 12.8954 10 14C10 15.1046 9.10457 16 8 16C6.89543 16 6 15.1046 6 14C6 12.8954 6.89543 12 8 12Z"></path> <path d="M8 6C9.10457 6 10 6.89543 10 8C10 9.10457 9.10457 10 8 10C6.89543 10 6 9.10457 6 8C6 6.89543 6.89543 6 8 6Z"></path> <path d="M10 2C10 0.89543 9.10457 -4.82823e-08 8 0C6.89543 4.82823e-08 6 0.895431 6 2C6 3.10457 6.89543 4 8 4C9.10457 4 10 3.10457 10 2Z"></path></g></svg>
          </div>
        </div>
      </div>

      <!-- Local Inventory Cache details (tap the dot) -->
      <div *ngIf="syncSheetOpen" class="sync-sheet no-print">
        <div class="sync-row">
          <div class="sync-dot" [ngClass]="syncDotState()"></div>
          <div class="sync-text">{{syncDotTitle()}}</div>
          <div class="sync-close" (click)="toggleSyncSheet()">&times;</div>
        </div>
        <div class="sync-detail">
          <div>Connection: <b>{{connectivityService.isOnline() ? 'online' : 'offline'}}</b></div>
          <div *ngIf="cacheStatus">Item cache: <b>{{cacheStatus.itemCount | rf:'number'}} items</b><ng-container *ngIf="cacheStatus.lastSync"> · synced {{cacheStatus.lastSync | rf:'dateTime'}}</ng-container><ng-container *ngIf="cacheStatus.progress"> · loading page {{cacheStatus.progress.pages}}</ng-container></div>
          <div *ngIf="cacheStatus && cacheStatus.error" class="sync-error">{{cacheStatus.error}}</div>
          <div *ngIf="queueStatus">Waiting to send: <b>{{queueStatus.pending}}</b><ng-container *ngIf="queueStatus.lastPushedAt"> · last sent {{queueStatus.lastPushedAt | rf:'dateTime'}}</ng-container></div>
          <div *ngIf="purchase.offlineCopy" class="sync-error">Showing the copy saved on this device; the server will catch up when the connection returns.</div>
        </div>
        <div *ngIf="pendingStuck()" class="sync-failed">
          <div class="sync-failed-title">{{queueStatus.pending}} change{{queueStatus.pending === 1 ? '' : 's'}} still waiting to send</div>
          <div class="sync-failed-actions">
            <div class="sync-button retry" (click)="sendPendingNow()">Send {{queueStatus.pending}} change{{queueStatus.pending === 1 ? '' : 's'}} now</div>
          </div>
        </div>
        <div *ngIf="failedOps.length > 0" class="sync-failed">
          <div class="sync-failed-title">{{failedOps.length}} change{{failedOps.length === 1 ? '' : 's'}} could not be applied</div>
          <div *ngIf="unavailable" class="sync-failed-row sync-failed-reason">{{unavailableText(unavailable.status, unavailable.detail || purchase)}}</div>
          <!-- Actions FIRST: on a 4" handheld the sheet has no room for a long
               list, and Retry must never be below the fold. No Retry once the
               transfer itself is gone: it would fail the same way every time. -->
          <div class="sync-failed-actions">
            <div *ngIf="!unavailable" class="sync-button retry" (click)="retryFailedOps()">Retry {{failedOps.length}} change{{failedOps.length === 1 ? '' : 's'}}</div>
            <div class="sync-link" (click)="dismissFailedOps()">Dismiss</div>
          </div>
          <div *ngFor="let op of failedOps | slice:0:3" class="sync-failed-row">{{op.kind}} · {{op.error}}</div>
          <div *ngIf="failedOps.length > 3" class="sync-failed-row">… and {{failedOps.length - 3}} more</div>
        </div>
        <!-- Failed changes made on this device to OTHER transfers, one group
             per transfer: which one, why it refused them, and what to do. -->
        <div *ngFor="let group of otherFailedGroups" class="sync-failed">
          <div class="sync-failed-title">{{group.count}} change{{group.count === 1 ? '' : 's'}} on {{group.label}} could not be applied</div>
          <div class="sync-failed-row sync-failed-reason">{{group.status ? unavailableText(group.status, group.detail) : group.sample[0]}}</div>
          <div class="sync-failed-actions">
            <div *ngIf="!group.status" class="sync-button retry" (click)="retryFailedGroup(group)">Retry {{group.count}} change{{group.count === 1 ? '' : 's'}}</div>
            <div class="sync-link" (click)="dismissFailedGroup(group)">Dismiss</div>
            <div *ngIf="group.status !== 'deleted' && group.status !== 'missing'" class="sync-link" (click)="openTransfer(group)">Open</div>
          </div>
          <ng-container *ngIf="!group.status && group.sample.length > 1">
            <div *ngFor="let line of group.sample | slice:1" class="sync-failed-row">{{line}}</div>
            <div *ngIf="group.count > group.sample.length" class="sync-failed-row">… and {{group.count - group.sample.length}} more</div>
          </ng-container>
        </div>
        <div class="sync-actions">
          <div class="sync-link" (click)="syncNow()">Sync now</div>
        </div>
      </div>

      <!-- 15-minute stale queue alert: persistent, must be dismissed, never takes focus. -->
      <div *ngIf="staleAlertOpen" class="stale-alert no-print">
        <div class="stale-text">{{staleAlertText}}</div>
        <div class="stale-dismiss" (click)="dismissStaleAlert()">Dismiss</div>
      </div>

      <div *ngIf="purchase.note && purchase.note[0] && purchase.note[0].length > 0" class="purchase-note" (click)="startEditSettings()" [innerHTML]="purchase.note[0] | rf:'nl2br'"></div>

      <!-- The server closed this transfer while it was open here (or it was
           opened after being deleted): read-only from now on, and this says why. -->
      <div *ngIf="unavailable || purchase.status === 'deleted'" class="canceled-banner unavailable-banner">
        {{unavailableText(unavailable ? unavailable.status : purchase.status, unavailable && unavailable.detail ? unavailable.detail : purchase)}}
        Scans here are no longer saved.
        <div *ngIf="failedOps.length > 0" class="unavailable-failed">
          {{failedOps.length}} change{{failedOps.length === 1 ? '' : 's'}} made on this device could not be applied.
          <span class="resume-cancel" (click)="dismissFailedOps()">Dismiss</span>
        </div>
      </div>
      <div *ngIf="purchase.status === 'canceled' && !unavailable" class="canceled-banner">
        This transfer was canceled<ng-container *ngIf="purchase.cancelUserName"> by {{purchase.cancelUserName}}</ng-container><ng-container *ngIf="purchase.timeCanceled"> on {{purchase.timeCanceled | rf:'dateTime'}}</ng-container>.
      </div>
      <div *ngIf="purchase.status === 'canceling'" class="canceled-banner">
        This transfer's cancelation was interrupted before it finished.
        <span *ngIf="purchase.cancelAllowed" class="resume-cancel" (click)="cancelTransfer()">Resume Cancel</span>
      </div>
      <!-- Reversed: every inventory movement this transfer made has been
           posted back. The transfer stays on record; nothing here is editable. -->
      <div *ngIf="purchase.status === 'reversed' && !unavailable" class="canceled-banner reversed-banner" data-cy="reversed-banner">
        This transfer was reversed<ng-container *ngIf="purchase.reverseUserName"> by {{purchase.reverseUserName}}</ng-container><ng-container *ngIf="purchase.timeReversed"> on {{purchase.timeReversed | rf:'dateTime'}}</ng-container>.
        <div *ngIf="purchase.reversalReason" class="reversal-reason">Reason: {{purchase.reversalReason}}</div>
        <div *ngIf="purchase.reversalSummary" class="reversal-detail">{{purchase.reversalSummary.mirrored | number}} inventory transaction{{purchase.reversalSummary.mirrored === 1 ? '' : 's'}} posted back.</div>
      </div>
      <div *ngIf="purchase.status === 'reversing'" class="canceled-banner reversed-banner" data-cy="reversing-banner">
        <ng-container *ngIf="purchase.reversalInProgress">
          This transfer is being reversed<ng-container *ngIf="purchase.processingProgress"> — {{purchase.processingProgress.done | number}} of {{purchase.processingProgress.total | number}} transactions posted</ng-container>…
        </ng-container>
        <ng-container *ngIf="!purchase.reversalInProgress">
          This transfer's reversal did not finish<ng-container *ngIf="purchase.reversalErrors && purchase.reversalErrors.length"> — {{purchase.reversalErrors.length}} transaction{{purchase.reversalErrors.length === 1 ? '' : 's'}} could not be posted</ng-container>.
          <span *ngIf="purchase.reverseAllowed" class="resume-cancel" (click)="reverseTransfer()">Resume Reversal</span>
          <div *ngFor="let error of purchase.reversalErrors || []" class="reversal-detail">{{error.msg}}</div>
        </ng-container>
        <div *ngIf="purchase.reversalReason" class="reversal-reason">Reason: {{purchase.reversalReason}}</div>
      </div>

  
      <ng-container *ngIf="purchase.status == 'open' || purchase.status == 'pending' || (hasSteps() && !isLocked() && currentStepInfo())">
        <div class="search no-print">
          <input type="text" [placeholder]="hasSteps() && !canAddRemove() ? 'FIND ITEM ON TRANSFER' : 'SEARCH'" [(ngModel)]="purchase.searchText" (ngModelChange)="searchInventory()" (keydown)="searchKeyDown($event)" />
          <svg *ngIf="purchase.searching" class="processing" width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1639 1056q0 5-1 7-64 268-268 434.5t-478 166.5q-146 0-282.5-55t-243.5-157l-129 129q-19 19-45 19t-45-19-19-45v-448q0-26 19-45t45-19h448q26 0 45 19t19 45-19 45l-137 137q71 66 161 102t187 36q134 0 250-65t186-179q11-17 53-117 8-23 30-23h192q13 0 22.5 9.5t9.5 22.5zm25-800v448q0 26-19 45t-45 19h-448q-26 0-45-19t-19-45 19-45l138-138q-148-137-349-137-134 0-250 65t-186 179q-11 17-53 117-8 23-30 23h-199q-13 0-22.5-9.5t-9.5-22.5v-7q65-268 270-434.5t480-166.5q146 0 284 55.5t245 156.5l130-129q19-19 45-19t45 19 19 45z"/></svg>
          <svg *ngIf="purchase.searchText && !purchase.searching" class="clear" (click)="clearSearch()" width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1490 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z"/></svg>
        </div>
        <!-- mobile-scanner opts the results out of the narrow-window column
             hiding — the mobile layout is purpose-built for inventory scanners -->
        <div *ngIf="purchase.searchText" class="search-results" [class.mobile-scanner]="purchase.isMobile">
          <div *ngIf="purchase.searchResults && purchase.searchResults.length == 0" class="no-results">No Results</div>
          <ng-container *ngIf="purchase.searchResults && purchase.searchResults.length > 0">
            <div *ngFor="let searchResult of purchase.searchResults; let resultIndex=index;" class="search-result" (click)="selectSearchResult(searchResult)">
              <div *ngFor="let col of searchResultFields()" [class]="col.class">{{searchResultValue(searchResult, col.path)}}</div>
            </div>
          </ng-container>
        </div>
      </ng-container>
  










      <!-- Purchase Table Start -->
      <!-- Print rows are built only while printing (beforeprint → afterprint):
           on a 20k-line count they were 120k always-present DOM nodes that every
           change-detection pass walked, which made handheld scanners crawl. -->
      <ng-container *ngIf="printing">
      <div class="items-header-print print-only">
        <div class="print-sku">{{identifierLabel()}}</div>
        <div class="print-name">Item</div>
        <ng-container *ngFor="let field of getStatusFields(purchase.typeObject, purchase.status)">
          <div [ngClass]="field.class" >{{field.label}}</div>
        </ng-container>
      </div>

      <div class="inventory-table print-only">
        <div *ngFor="let item of displayItems; let itemIndex = index;" class="row">
          <div class="print-sku">{{itemIdentifier(item)}}</div>
          <div class="print-name">{{item.name}} ({{item.unitOfMeasure}}) {{item.unitDescription}}</div>
          <ng-container *ngFor="let field of getStatusFields(purchase.typeObject, purchase.status)">
            <div *ngIf="!purchase.isMobile || field.displayMobile" [ngClass]="field.class">
              <ng-container *ngIf="isOnHandPending(item, field); else printValue">&mdash;</ng-container>
              <ng-template #printValue>{{item[field.key] | rf:field.pipe}}</ng-template>
            </div>
          </ng-container>
        </div>
      </div>
      </ng-container>
  



      <!-- items-scroll: shared horizontal scroller for the column headers and
           the rows (phone widths). The identity column pins to the left edge
           via a scroll-driven translate — position:sticky dies inside the
           virtual scroll viewport's translateY transform. -->
      <!-- Active list filters, so a short list never looks like a short transfer. -->
      <div *ngIf="filtersActive()" class="list-filter-bar no-print" (click)="transferControlsLaunch()">
        <span class="summary">{{filterSummary()}} — {{filterCounts.visible | number}} of {{filterCounts.total | number}}</span>
        <span class="change">Change</span>
      </div>
      <div *ngIf="filtersActive() && filterCounts.visible === 0 && filterCounts.total > 0" class="list-filter-empty no-print">
        {{filterEmptyMessage()}}
      </div>
      <div class="items-scroll" (scroll)="itemsScrolled($event)">
      <div class="items-header">
        <div *ngIf="canAddRemove()" class="item-remove no-print">&nbsp;</div>
        <!-- Item #-primary clients label the identity column just "Item" (the
             item number still renders inside it); SKU clients keep SKU/Item. -->
        <div class="sku-name sortable" (click)="sortBy('name')">{{itemNumberPrimary() ? 'Item' : identifierLabel() + '/Item'}}<span *ngIf="sortKey === 'name'" class="sort-arrow">{{sortDirection === 1 ? '\u25b2' : '\u25bc'}}</span></div>
        <ng-container *ngFor="let field of getStatusFields(purchase.typeObject, purchase.status)">
          <div *ngIf="!purchase.isMobile || field.displayMobile" [ngClass]="field.class" class="sortable" (click)="sortBy(field.key)">{{field.label}}<span *ngIf="sortKey === field.key" class="sort-arrow">{{sortDirection === 1 ? '\u25b2' : '\u25bc'}}</span></div>
        </ng-container>
        <div *ngIf="!purchase.isMobile" class="scrollbar-spacer"></div>
      </div>

      <cdk-virtual-scroll-viewport itemSize="50" minBufferPx="500" maxBufferPx="500" class="inventory-table no-print" id="inventory-table">
        <ng-container *cdkVirtualFor="let item of displayItems; let itemIndex = index;">
            <div class="row" *ngIf="itemVisible(item)" [class.active-row]="item && item == activeItem" [class.deleted-line]="item.accountDeleted" [class.even]="itemIndex % 2 == 0" [class.counted]="item.counted" [class.high]="item.qty > item.expectedQty && purchase.type == 'retail-retail' && item.counted" [class.low]="item.qty < item.expectedQty && purchase.type == 'retail-retail' && item.counted" [class.lastItem]="itemIndex === displayItems.length-1" id="item-{{item.index}}" (click)="setActiveItem(item.index)">
                <div *ngIf="canAddRemove()" class="item-remove no-print" (click)="removePurchaseItem(item.index)">
                    <svg *ngIf="!item.saving" class="remove" width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M704 1376v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm256 0v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zm-544-992h448l-48-117q-7-9-17-11h-317q-10 2-17 11zm928 32v64q0 14-9 23t-23 9h-96v948q0 83-47 143.5t-113 60.5h-832q-66 0-113-58.5t-47-141.5v-952h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h309l70-167q15-37 54-63t79-26h320q40 0 79 26t54 63l70 167h309q14 0 23 9t9 23z"/></svg>
                    <svg *ngIf="item.saving" class="processing" width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1639 1056q0 5-1 7-64 268-268 434.5t-478 166.5q-146 0-282.5-55t-243.5-157l-129 129q-19 19-45 19t-45-19-19-45v-448q0-26 19-45t45-19h448q26 0 45 19t19 45-19 45l-137 137q71 66 161 102t187 36q134 0 250-65t186-179q11-17 53-117 8-23 30-23h192q13 0 22.5 9.5t9.5 22.5zm25-800v448q0 26-19 45t-45 19h-448q-26 0-45-19t-19-45 19-45l138-138q-148-137-349-137-134 0-250 65t-186 179q-11 17-53 117-8 23-30 23h-199q-13 0-22.5-9.5t-9.5-22.5v-7q65-268 270-434.5t480-166.5q146 0 284 55.5t245 156.5l130-129q19-19 45-19t45 19 19 45z"/></svg>
                </div>
                <div class="sku-name" [class.view-link]="canOpenItemView(item)" (click)="openItemView(item, $event)">
                    <div class="sku">{{itemIdentifier(item)}}</div>
                    <div class="name">{{item.name}}<span *ngIf="item.accountDeleted" class="deleted-tag no-print">
                      <span class="deleted-label">PRODUCT DELETED</span>
                      <span *ngIf="item.replacement && canAddRemove()" class="replace-link" (click)="startReplaceItem(item); $event.stopPropagation()">Replace with {{item.replacement.name}}<span *ngIf="item.replacement.unitDescription"> ({{item.replacement.unitDescription}})</span></span>
                      <span *ngIf="!item.replacement && canAddRemove()" class="replace-hint">remove this line</span>
                    </span></div>
                    <div class="units">{{item.unitOfMeasure}} {{item.unitDescription}}<span *ngIf="item.attr"> · {{item.attr}}</span><span *ngIf="item.unexpected" class="unexpected-tag"> · UNEXPECTED</span></div>
                </div>

                <ng-container *ngFor="let field of getStatusFields(purchase.typeObject, purchase.status)">
                  <div *ngIf="!purchase.isMobile || field.displayMobile" [ngClass]="field.class" (click)="fieldClick(field, item)"
                    [class.empty-cell]="item[field.key] === null || item[field.key] === undefined || item[field.key] === ''"
                    [class.required-missing]="field.required && isBlank(item[field.key])"
                    [class.increment-warning]="field.key === 'qty' && item.incrementWarning"
                    [title]="(field.key === 'qty' && item.incrementWarning) ? 'Not a multiple of the order increment (' + item.orderIncrement + ')' : ''">
                    <ng-container *ngIf="!field.editable || item != activeItem || purchase.isMobile">
                      <ng-container *ngIf="isOnHandPending(item, field); else cellValue">&mdash;</ng-container>
                      <ng-template #cellValue>{{item[field.key] | rf:field.pipe}}</ng-template>
                      <span *ngIf="field.editable && hasOtherShares(item)" class="share-badge" [title]="'Counted on more than one device'">&#8203;+</span>
                      <span *ngIf="field.required && isBlank(item[field.key]) && canEdit()" class="required-hint no-print">{{field.label}} required</span>
                    </ng-container>
                    <ng-container *ngIf="field.editable && item == activeItem && !purchase.isMobile">
                      <!-- Text step fields (e.g. a required Note) edit as free text and never become the numeric input target. -->
                      <input *ngIf="!isTextField(field)" type="number" id="item-{{item.index}}-{{field.key}}" [(ngModel)]="item[field.key]" (focus)="setInputTargetField(field.key, true, $event)" (ngModelChange)="qtyChange($event)" (blur)="confirmChange(item)" (keydown)="countInputKeydown($event, item, field)" (keydown.Tab)="fieldTab($event);false" />
                      <input *ngIf="isTextField(field)" type="text" class="text-field" id="item-{{item.index}}-{{field.key}}" [(ngModel)]="item[field.key]" (ngModelChange)="item.edited = true" (blur)="confirmChange(item)" (keydown.enter)="confirmChange(item)" (keydown.Tab)="fieldTab($event);false" [placeholder]="field.required ? field.label + ' required' : field.label" [attr.maxlength]="500" />
                    </ng-container>
                    <span *ngIf="field.unitOf && item.unitRounding" class="unit-hint" [title]="'Rounded up to whole ' + (item.unitOfMeasure || 'vendor units')">from {{item.unitRounding.entered | rf:'number'}}</span>
                  </div>
                </ng-container>

            </div>

        </ng-container>

        <div class="virtual-spacer"></div>
        <div class="virtual-spacer"></div>
        <div class="virtual-spacer"></div>
        <div class="virtual-spacer"></div>
        <div class="virtual-spacer"></div>
        <div class="virtual-spacer"></div>
        <div class="virtual-spacer"></div>
        <div class="virtual-spacer"></div>
        <div class="virtual-spacer"></div>
        <div class="virtual-spacer"></div>
        <div class="virtual-spacer"></div>

      </cdk-virtual-scroll-viewport>
      </div>

      <div class="items-footer">

        <div *ngIf="purchase.status == 'pending' && (purchase.authorization.complete || purchase.authorization.reopen) && !purchase.isMobile" class="button yellow" (click)="updateTransferStatus('open')">Edit</div>

        <div *ngIf="hasSteps() && canRegress() && !purchase.isMobile" class="button yellow" (click)="regressStep()">{{regressLabel()}}</div>

        <div *ngIf="canAddRemove() && !purchase.isMobile && purchase.authorization.update && bulkAddAvailable()" class="button green" (click)="bulkAddLaunch()">Bulk Add</div>
        <div *ngIf="purchase.items.length > 0 && canAddRemove() && !purchase.isMobile && purchase.authorization.update" class="button red" (click)="removeAll()">Remove All</div>
        <div *ngIf="purchase.items.length == 0 && isFirstStep() && !purchase.isMobile && purchase.authorization.update" class="button red" (click)="delete()">Delete Transfer</div>


        <div class="stretcher"></div>
        <div class="purchase-stat">
          <div class="label">Lines:</div>
          <div class="value">{{purchase.items.length | rf:'number'}}</div>
        </div>
        <div class="purchase-stat">
          <div class="label">Qty:</div>
          <div class="value">{{purchase.qtyTotal | rf:'number'}}</div>
        </div>
        <div *ngIf="purchase.unitTotal != null" class="purchase-stat">
          <div class="label">Units:</div>
          <div class="value">{{purchase.unitTotal | rf:'number'}}</div>
        </div>
        <div *ngIf="!purchase.typeObject.hideCostTotal" class="purchase-stat">
          <div class="label">Total:</div>
          <div class="value">{{purchase.costTotal | rf:'currency'}}</div>
        </div>

        <!-- Desktop only: commits and closes the active row's open edit. On
             mobile it's a no-op (the active-item panel has its own Save
             Change and covers this footer while an item is selected). -->
        <div *ngIf="canEdit() && !purchase.isMobile" class="button green" (click)="saveButton()">Save</div>
        <div *ngIf="!hasSteps() && purchase.status == 'open' && purchase.authorization.update && purchase.typeObject.fields.pending && purchase.typeObject.fields.pending.length > 0" class="button green" (click)="startEditStatus('pending')">Send</div>
        <div *ngIf="purchase.status == 'pending' && purchase.authorization.complete && purchase.uncounted > 0 && !purchase.isMobile && purchase.typeObject.requirePendingCount" class="button yellow" (click)="markAllCounted()">All Counted</div>
        <div *ngIf="purchase.status == 'pending' && purchase.authorization.complete && !purchase.isMobile && !purchase.typeObject.defaultPendingQty" class="button yellow" (click)="markAllReceived()">All Received</div>
        <div *ngIf="purchase.status == 'pending' && purchase.authorization.complete && (!purchase.typeObject.requirePendingCount || purchase.uncounted == 0 || !purchase.isMobile)" class="button green" (click)="complete()">Complete</div>
        <div *ngIf="hasSteps() && canProceed() && !proceedBlockedByCount()" class="button green" (click)="proceedStep()">{{proceedLabel()}}</div>
        <div *ngIf="purchase.status == 'processing' && purchase.authorization.retry && !purchase.retrying" class="button yellow" (click)="retry()">Retry</div>
        <div *ngIf="purchase.status == 'processing' && purchase.retrying" class="button yellow disabled retrying-indicator">
          <svg class="processing" width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1639 1056q0 5-1 7-64 268-268 434.5t-478 166.5q-146 0-282.5-55t-243.5-157l-129 129q-19 19-45 19t-45-19-19-45v-448q0-26 19-45t45-19h448q26 0 45 19t19 45-19 45l-137 137q71 66 161 102t187 36q134 0 250-65t186-179q11-17 53-117 8-23 30-23h192q13 0 22.5 9.5t9.5 22.5zm25-800v448q0 26-19 45t-45 19h-448q-26 0-45-19t-19-45 19-45l138-138q-148-137-349-137-134 0-250 65t-186 179q-11 17-53 117-8 23-30 23h-199q-13 0-22.5-9.5t-9.5-22.5v-7q65-268 270-434.5t480-166.5q146 0 284 55.5t245 156.5l130-129q19-19 45-19t45 19 19 45z"/></svg>
          Processing<ng-container *ngIf="purchase.processingProgress?.total">&nbsp;{{purchase.processingProgress.done | rf:'number'}} / {{purchase.processingProgress.total | rf:'number'}}</ng-container>&hellip;
        </div>

      </div>
      <div class="status">
        <div class="purchase-status">{{purchase.statusName || purchase.status}}</div>
        <div class="app-version">v{{version}}</div>
        <div class="saved-status">Saved: {{purchase.timeUpdated | rf:'dateTime'}}</div>
      </div>
      <!-- Purchase Table End -->








      <div *ngIf="activeItem" class="active-item no-print">
        <div class="window">
          <div *ngIf="false" class="active-item-detail">Set Value / Add to Value  |  Unit Options</div>
        </div>
        <div class="body">
            <div class="count">
              <ng-container *ngFor="let field of getStatusFields(purchase.typeObject, purchase.status)">
                <div *ngIf="(field.displayMobile || field.editable) && !isTextField(field)" [class.active]="purchase.inputTargetField == field.key" (click)="setInputTargetField(field.key, field.editable)">
                  <div class="label">{{field.label}}</div>
                  <div class="value">

                    

                    <div *ngIf="showSplitControls(field) && (activeItem.previousCount !== undefined)" class="previous-count tappable" (click)="enterChangeCountMode($event)" [title]="splitLabels().hint">{{activeItem.previousCount | rf:number}} + </div>
                    {{panelValue(activeItem, field) | rf:field.pipe}}
                    <div *ngIf="showSplitControls(field) && inChangeCountMode(activeItem)" class="count-mode-link" (click)="enterAddCountMode($event)">{{splitLabels().add}}</div>
                    <span *ngIf="field.unitOf && activeItem.unitRounding" class="unit-hint">from {{activeItem.unitRounding.entered | rf:'number'}}</span>



                  </div>
                </div>
              </ng-container>
            </div>
    
            <!-- Text step fields (a Note, etc.) edit here on the phone; Save Change persists them. -->
            <div *ngFor="let field of textFields()" class="text-field-edit" [class.required-missing]="field.required && isBlank(activeItem[field.key])">
              <label>{{field.label}}<span *ngIf="field.required" class="required-tag"> required</span></label>
              <textarea *ngIf="textFieldEditable(field)" rows="2" maxlength="500" [(ngModel)]="activeItem[field.key]" (ngModelChange)="activeItem.edited = true" [placeholder]="field.label"></textarea>
              <div *ngIf="!textFieldEditable(field)" class="text-value">{{activeItem[field.key] || '—'}}</div>
            </div>

            <div *ngIf="showNumberpad() && activeFieldEditable()" class="num-pad">
                <div class="ripple-btn" (click)="screenBtnPress(1)">1</div>
                <div class="ripple-btn" (click)="screenBtnPress(2)">2</div>
                <div class="ripple-btn" (click)="screenBtnPress(3)">3</div>
                <div class="ripple-btn" (click)="screenBtnPress(4)">4</div>
                <div class="ripple-btn" (click)="screenBtnPress(5)">5</div>
                <div class="ripple-btn" (click)="screenBtnPress(6)">6</div>
                <div class="ripple-btn" (click)="screenBtnPress(7)">7</div>
                <div class="ripple-btn" (click)="screenBtnPress(8)">8</div>
                <div class="ripple-btn" (click)="screenBtnPress(9)">9</div>
                <div class="ripple-btn" (click)="screenBtnPress('c')">C</div>
                <div class="ripple-btn" (click)="screenBtnPress(0)">0</div>
                <div class="ripple-btn" (click)="screenBtnPress('d')">&lt;</div>
                <div *ngIf="getInfoFields().length > 0" class="info-btn ripple-btn" (click)="openItemInfo()">
                    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"/></svg>
                    Item Info
                </div>
            </div>

            <!-- Read-only steps (no editable target field) show this info panel
                 on every device config, without the correction controls. -->
            <div *ngIf="!showNumberpad() || !activeFieldEditable()" class="item-info">
                <!-- Touch corrections for keypad-device layouts: subtract,
                     reset to zero, add — routed through the input target field.
                     Numberpad clients never render this panel and keep the
                     plain tap-to-add-one behavior. -->
                <div *ngIf="activeFieldEditable()" class="qty-adjust">
                    <div class="adjust-btn minus" (click)="stepActiveValue(-1)">&minus;</div>
                    <div class="adjust-btn reset" (click)="resetActiveValue()">Reset</div>
                    <div class="adjust-btn plus" (click)="stepActiveValue(1)">+</div>
                </div>
                <div class="item-info-header">
                    <div class="sku">{{itemIdentifier(activeItem)}}</div>
                    <div class="name">{{activeItem.name}}</div>
                </div>
                <ng-container *ngTemplateOutlet="itemInfoRows"></ng-container>
            </div>

        </div>
        <div class="buttons">
            <div *ngIf="canAddRemove()" class="red" (click)="removePurchaseItem(activeItem.index)">Remove<br/>Item</div>
            <div class="yellow" (click)="cancel()"><ng-container *ngIf="activeFieldEditable()">Discard<br/>Change</ng-container><ng-container *ngIf="!activeFieldEditable()">Close</ng-container></div>
            <div *ngIf="activeFieldEditable() || textFieldsEditable()" class="green" (click)="saveItem()">Save<br/>Change</div>
        </div>
      </div>
    </ng-container>

    <!-- Item detail view side panel (details/:viewKey/:documentId child route) -->
    <router-outlet></router-outlet>

  </div>




  <!-- ITEM INFO DETAIL ROWS (shared by the in-place panel and the modal) -->
  <!-- Only rows with a value are listed; fields the item lacks are omitted. -->
  <ng-template #itemInfoRows>
    <ng-container *ngFor="let field of displayInfoFields()">
      <div *ngIf="hasItemInfoValue(field)" class="item-info-row">
        <div class="label">{{field.label}}</div>
        <div class="value">{{itemInfoValue(field) | rf:field.pipe}}</div>
      </div>
    </ng-container>
  </ng-template>

  <!-- ITEM INFO MODAL (numberpad devices) -->
  <!-- Full-screen item search for handhelds (opened from Transfer Controls).
       Reuses the inline search state and result rendering. On add-allowed
       steps a result is added to the transfer (or selected if already on it);
       on locked steps it activates the line without counting it. -->
  <div *ngIf="purchase.findModal" class="find-modal no-print">
    <div class="find-modal-header">
      <input id="find-item-input" type="text" [placeholder]="canAddRemove() ? 'SEARCH ITEMS TO ADD' : 'FIND ITEM ON TRANSFER'" autocomplete="off"
        [(ngModel)]="purchase.searchText" (ngModelChange)="findModalTextChanged()" (keydown)="searchKeyDown($event)" />
      <div class="cancel" (click)="closeFindModal()">Cancel</div>
    </div>
    <div *ngIf="purchase.findInventoryMode" class="find-mode-banner">
      Showing items NOT on this transfer &mdash; selecting one receives it as UNEXPECTED
    </div>
    <div class="search-results mobile-scanner">
      <!-- Search runs on Enter (not per keystroke) so the keyboard can be
           dismissed before the results show — see searchOnEnter(). -->
      <div *ngIf="purchase.searchText && !purchase.searchResults && !purchase.searching" class="search-hint">Press Enter to search</div>
      <div *ngIf="purchase.searchText && purchase.searchResults && purchase.searchResults.length == 0" class="no-results">No Results</div>
      <div *ngIf="purchase.searchText && purchase.searchResults && purchase.searchResults.length == 0 && !purchase.findInventoryMode && canUnexpectedAdd()"
        class="no-results-actions">
        <div class="button" (click)="searchOffTransfer()">Search Items Not on This Transfer</div>
      </div>
      <ng-container *ngIf="purchase.searchResults && purchase.searchResults.length > 0">
        <div *ngFor="let searchResult of purchase.searchResults" class="search-result" (click)="selectSearchResult(searchResult)">
          <div *ngFor="let col of searchResultFields()" [class]="col.class">{{searchResultValue(searchResult, col.path)}}</div>
        </div>
      </ng-container>
    </div>
  </div>

  <div *ngIf="itemInfoModal && activeItem" class="modal-wrapper" (mousedown)="closeItemInfo()">
    <div class="modal-contents" (mousedown)="stopPropagation($event)">
      <div class="modal-header">{{activeItem.name}}</div>
      <div class="modal-body">
        <div class="modal-item-info">
          <ng-container *ngTemplateOutlet="itemInfoRows"></ng-container>
        </div>
      </div>
      <div class="modal-buttons">
        <div class="spacer"></div>
        <div class="modal-button" (click)="closeItemInfo()">Close</div>
      </div>
    </div>
  </div>

  <!-- EDIT TRANSFER SETTINGS -->
  <div *ngIf="purchase.settingsEdit" class="modal-wrapper" (mousedown)="cancelSettingsEdit()">
    <div class="modal-contents" (mousedown)="stopPropagation($event)">
      <div class="modal-header">Transfer Settings</div>
      <div class="modal-body">

        <div *ngIf="showTransferName()" class="setting">
          <div class="label">Transfer Name</div>
          <div class="value">
            <input type="text" [(ngModel)]="purchase.settingsEdit.name" />
          </div>
        </div>

        <div *ngFor="let field of customFields()" class="setting custom-field" [class.required-missing]="field.required && isBlank(purchase.settingsEdit[field.key])">
          <div class="label">{{field.name}}</div>
          <div class="value">
            <input type="text" [(ngModel)]="purchase.settingsEdit[field.key]" [attr.data-cy]="'settings-custom-field-' + field.key" />
          </div>
          <div *ngIf="field.required && isBlank(purchase.settingsEdit[field.key])" class="required-hint">{{field.name}} is required</div>
        </div>

        <div class="setting">
          <div class="label">Notes</div>
          <div class="value">
            <textarea [(ngModel)]="purchase.settingsEdit.note"></textarea>
          </div>
        </div>

      </div>
      <div class="modal-buttons">
        <div class="modal-button" (click)="cancelSettingsEdit()">Cancel</div>
        <div class="modal-button" (click)="saveSettingsEdit()">Save</div>
      </div>
    </div>
  </div>

  <!-- EDIT TRANSFER ITEM COST -->
  <div *ngIf="purchase.costEdit" class="modal-wrapper" (mousedown)="cancelCostEdit()">
    <div class="modal-contents" (mousedown)="stopPropagation($event)">
      <div class="modal-header">{{purchase.costEdit.item.name}} {{purchase.costEdit.fieldLabel}}</div>
      <div class="modal-body">

        <div class="setting">
          <div class="label">{{purchase.costEdit.fieldLabel}}</div>
          <div class="value">
            <input type="number" step="0.0001" min="0" inputmode="decimal" [(ngModel)]="purchase.costEdit.cost" />
            <div class="hint">Up to 4 decimal places</div>
          </div>
        </div>

      </div>
      <div class="modal-buttons">
        <div class="modal-button" (click)="cancelCostEdit()">Cancel</div>
        <div class="modal-button" (click)="saveCostEdit()">Save</div>
      </div>
    </div>
  </div>

  <!-- REPLACE A DELETED LINE -->
  <div *ngIf="purchase.replaceEdit" class="modal-wrapper" (mousedown)="cancelReplaceItem()">
    <div class="modal-contents" (mousedown)="stopPropagation($event)">
      <div class="modal-header">Replace {{purchase.replaceEdit.item.name}}</div>
      <div class="modal-body">
        <div class="msg">
          {{purchase.replaceEdit.item.name}} was deleted from the catalog. Replace it with
          <strong>{{purchase.replaceEdit.replacement.name}}</strong><span *ngIf="purchase.replaceEdit.replacement.unitDescription"> ({{purchase.replaceEdit.replacement.unitDescription}})</span>
          at {{purchase.replaceEdit.replacement.price | rf:'currency'}} per vendor unit.
        </div>
        <div class="msg" *ngIf="purchase.replaceEdit.oldCase !== purchase.replaceEdit.newCase">
          Pack sizes differ: the line was {{purchase.replaceEdit.item.qty}} × {{purchase.replaceEdit.oldCase}} units; the replacement holds {{purchase.replaceEdit.newCase}} per vendor unit.
        </div>
        <div class="setting">
          <div class="label">Vendor Unit Qty</div>
          <div class="value">
            <input type="number" min="1" step="1" [(ngModel)]="purchase.replaceEdit.qty" (keydown.enter)="confirmReplaceItem()" />
          </div>
        </div>
      </div>
      <div class="modal-buttons">
        <div class="modal-button" (click)="cancelReplaceItem()">Cancel</div>
        <div class="modal-button" (click)="confirmReplaceItem()">Replace</div>
      </div>
    </div>
  </div>

  <!-- CONFIRM TRANSFER STATUS CHANGE -->
  <div *ngIf="purchase.statusEdit" class="modal-wrapper" (mousedown)="cancelEditStatus()">
    <div class="modal-contents" [class.wide]="purchase.statusEdit.detailRows" (mousedown)="stopPropagation($event)">
      <div class="modal-header">Confirm Status Change</div>
      <div class="modal-body">

        <div class="msg">
          {{purchase.statusEdit.msg}}
        </div>

        <div *ngIf="purchase.statusEdit.detail" class="msg">
          <div *ngFor="let line of purchase.statusEdit.detail">{{line}}</div>
        </div>

        <div *ngIf="purchase.statusEdit.detailRows" class="discrepancy-table-wrapper">
          <table class="discrepancy-table">
            <thead>
              <tr>
                <th class="sortable" (click)="sortStatusDetail('itemNumber')">Item #<span *ngIf="statusDetailSortKey === 'itemNumber'" class="sort-arrow">{{statusDetailSortDirection === 1 ? '▲' : '▼'}}</span></th>
                <th class="sortable" (click)="sortStatusDetail('name')">Product Name<span *ngIf="statusDetailSortKey === 'name'" class="sort-arrow">{{statusDetailSortDirection === 1 ? '▲' : '▼'}}</span></th>
                <th class="sortable" (click)="sortStatusDetail('unitDescription')">Size<span *ngIf="statusDetailSortKey === 'unitDescription'" class="sort-arrow">{{statusDetailSortDirection === 1 ? '▲' : '▼'}}</span></th>
                <th class="sortable" (click)="sortStatusDetail('attr')">Attribute<span *ngIf="statusDetailSortKey === 'attr'" class="sort-arrow">{{statusDetailSortDirection === 1 ? '▲' : '▼'}}</span></th>
                <th class="sortable num" (click)="sortStatusDetail('expectedQty')">Expected<span *ngIf="statusDetailSortKey === 'expectedQty'" class="sort-arrow">{{statusDetailSortDirection === 1 ? '▲' : '▼'}}</span></th>
                <th class="sortable num" (click)="sortStatusDetail('qty')">Actual<span *ngIf="statusDetailSortKey === 'qty'" class="sort-arrow">{{statusDetailSortDirection === 1 ? '▲' : '▼'}}</span></th>
                <th class="sortable num" (click)="sortStatusDetail('differenceQty')">Difference<span *ngIf="statusDetailSortKey === 'differenceQty'" class="sort-arrow">{{statusDetailSortDirection === 1 ? '▲' : '▼'}}</span></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let row of purchase.statusEdit.detailRows">
                <td>{{row.itemNumber}}</td>
                <td>{{row.name}}</td>
                <td>{{row.unitDescription}}</td>
                <td>{{row.attr}}</td>
                <td class="num">{{row.expectedQty | rf:'number'}}</td>
                <td class="num">{{row.qty | rf:'number'}}</td>
                <td class="num" [class.short]="row.differenceQty < 0" [class.over]="row.differenceQty > 0">{{row.differenceQty > 0 ? '+' : ''}}{{row.differenceQty | rf:'number'}}</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
      <div class="modal-buttons">
        <div class="modal-button" (click)="cancelEditStatus()">Cancel</div>
        <div class="modal-button" (click)="updateTransferStatus(purchase.statusEdit.status, purchase.statusEdit.acknowledgeDiscrepancies)">Yes</div>
      </div>
    </div>
  </div>

  <!-- CONFIRM CANCEL TRANSFER -->
  <div *ngIf="purchase.cancelConfirm" class="modal-wrapper" (mousedown)="dismissCancelTransfer()">
    <div class="modal-contents" (mousedown)="stopPropagation($event)">
      <div class="modal-header">Cancel Transfer</div>
      <div class="modal-body">
        <div class="msg">
          Are you sure you want to cancel transfer {{purchase.key}}? Any inventory already picked up for
          transit will be returned to {{purchase.locationName}}. This cannot be undone.
        </div>
      </div>
      <div class="modal-buttons">
        <div class="modal-button" (click)="dismissCancelTransfer()">Keep Transfer</div>
        <div class="modal-button warn" (click)="cancelTransfer()">Cancel Transfer</div>
      </div>
    </div>
  </div>

  <!-- CONFIRM REVERSE TRANSFER: a completed transfer of any type. The reason
       is required — it is kept on the transfer and in its history. -->
  <div *ngIf="purchase.reverseConfirm" class="modal-wrapper" (mousedown)="dismissReverseTransfer()">
    <div class="modal-contents" (mousedown)="stopPropagation($event)">
      <div class="modal-header">Reverse Transfer</div>
      <div class="modal-body">
        <div class="msg">
          Reversing transfer {{purchase.key}} posts the opposite of every inventory movement it made,
          putting the stock back where it was before the transfer completed. The transfer stays on
          record as reversed. This cannot be undone.
        </div>
        <div class="setting reverse-reason">
          <div class="label">Reason <span class="required-hint">(required)</span></div>
          <div class="value">
            <textarea [(ngModel)]="purchase.reverseReason" maxlength="500" placeholder="Why is this transfer being reversed?" data-cy="reverse-reason"></textarea>
          </div>
        </div>
      </div>
      <div class="modal-buttons">
        <div class="modal-button" (click)="dismissReverseTransfer()">Keep Transfer</div>
        <div class="modal-button warn" [class.disabled]="!reverseReasonValid()" (click)="reverseTransfer()" data-cy="reverse-confirm">Reverse Transfer</div>
      </div>
    </div>
  </div>

  <!-- NOTIFY SCANNED ITEM NOT ON TRANSFER. Three shapes: normal add prompt,
       unexpected-item capture (allowUnexpectedAdd steps), or — when neither is
       possible — an honest informational message with no dead-end Add button. -->
  <div *ngIf="purchase.missingBarcode" class="modal-wrapper" (mousedown)="cancelMissingBarcode()">
    <div class="modal-contents" (mousedown)="stopPropagation($event)">
      <div class="modal-header">Item Not On Transfer</div>
      <div class="modal-body">

        <div class="msg">
          <div>{{purchase.missingBarcode}}</div>
          <div *ngIf="canAddRemove()">This item is not on this transfer. Do you still want to add it?</div>
          <div *ngIf="canUnexpectedAdd()">This item is not on this transfer. Receive it as an <b>UNEXPECTED</b> item? It will be recorded with Expected&nbsp;0 and flagged as a discrepancy for review.</div>
          <div *ngIf="!canAddRemove() && !canUnexpectedAdd()">This item is not on this transfer and cannot be added during the {{currentStepInfo()?.step?.name || purchase.statusName || purchase.status}} step.</div>
        </div>

      </div>
      <div class="modal-buttons">
        <div class="modal-button" (click)="cancelMissingBarcode()">{{(canAddRemove() || canUnexpectedAdd()) ? 'Cancel' : 'OK'}}</div>
        <div *ngIf="canAddRemove() || canUnexpectedAdd()" class="modal-button" (click)="barcodeEntered(purchase.missingBarcode, true); cancelMissingBarcode()">{{canUnexpectedAdd() ? 'Receive Unexpected' : 'Add'}}</div>
      </div>
    </div>
  </div>

  <!-- NOTIFY TRANSFER ERRORS -->
  <div *ngIf="purchase.errors && purchase.errors.length > 0" class="modal-wrapper" (mousedown)="cancelMissingBarcode()">
    <div class="modal-contents" (mousedown)="stopPropagation($event)">
      <div class="modal-header">Transfer Error</div>
      <div class="modal-body">

        <div *ngFor="let error of purchase.errors" class="msg">
          <div>{{error.msg}}</div>
        </div>

      </div>
      <div class="modal-buttons">
        <div class="spacer"></div>
        <div class="modal-button" (click)="acknowledgeErrors()">Ok</div>
      </div>
    </div>
  </div>

  <!-- TRANSFER CONTROLS -->
   <div *ngIf="purchase.controls" class="modal-wrapper" (mousedown)="cancelPurchaseControls()">
    <div class="modal-contents" (mousedown)="stopPropagation($event)">
      <div class="modal-header">Transfer Controls<div class="modal-close" title="Close" (click)="cancelPurchaseControls()">&times;</div></div>
      <div class="modal-body">
        
        <div class="controls-body">
          <!-- Handheld find-mode search: locate a line by item #, UPC, or name
               when a barcode is damaged or won't scan. Desktop keeps the
               inline search row instead. -->
          <div *ngIf="purchase.isMobile && hasSteps() && !canAddRemove()" class="button" (click)="cancelPurchaseControls(); openFindModal()">Find Item on Transfer</div>
          <!-- Handhelds hide the inline search row, so search-to-add on an
               add-allowed step (e.g. a warehouse-to-store build) lives here too. -->
          <div *ngIf="purchase.isMobile && canAddRemove()" class="button" (click)="cancelPurchaseControls(); openFindModal()">Search Items to Add</div>
          <!-- List filters: segmented controls — the highlighted segment is the
               current state, the other segment is what a tap switches to. -->
          <div class="filter-segments">
            <div class="filter-segment">
              <div class="filter-label">Items</div>
              <div class="segments">
                <div class="segment" [class.selected]="countedFilter === 'counted'" (click)="setCountedFilter('counted')">Counted only</div>
                <div class="segment" [class.selected]="countedFilter === 'all'" (click)="setCountedFilter('all')">Counted + uncounted</div>
                <div class="segment" [class.selected]="countedFilter === 'uncounted'" (click)="setCountedFilter('uncounted')">Uncounted only</div>
              </div>
            </div>
            <div class="filter-segment" [class.not-applicable]="!countedByApplies()" [title]="countedByApplies() ? '' : 'Not used while only uncounted items are shown'">
              <div class="filter-label">Counted by<span *ngIf="!countedByApplies()" class="filter-note"> — not used for uncounted items</span></div>
              <div class="segments">
                <div class="segment" [class.selected]="countedByMeOnly" (click)="setCountedByMe(true)">Me</div>
                <div class="segment" [class.selected]="!countedByMeOnly" (click)="setCountedByMe(false)">Anyone</div>
              </div>
            </div>
            <div class="filter-segment">
              <div class="filter-label">Discrepancies</div>
              <div class="segments">
                <div class="segment" [class.selected]="descrepancyOnly" (click)="setDiscrepancyOnly(true)">Discrepancies only</div>
                <div class="segment" [class.selected]="!descrepancyOnly" (click)="setDiscrepancyOnly(false)">All items</div>
              </div>
            </div>
            <div class="filter-count">{{filterCounts.visible | number}} of {{filterCounts.total | number}} items shown</div>
          </div>
          <!-- Regress lives here on phones — the footer stays lean for scanning work. -->
          <div *ngIf="purchase.isMobile && hasSteps() && canRegress()" class="button yellow" (click)="regressStep(); cancelPurchaseControls()">{{regressLabel()}}</div>
          <div *ngIf="purchase.cancelAllowed" class="button red" (click)="startCancelTransfer()">{{purchase.status === 'canceling' ? 'Resume Cancel' : 'Cancel Transfer'}}</div>
          <div *ngIf="purchase.reverseAllowed && !purchase.reversalInProgress" class="button red" (click)="purchase.status === 'reversing' ? reverseTransfer() : startReverseTransfer()" data-cy="reverse-transfer">{{purchase.status === 'reversing' ? 'Resume Reversal' : 'Reverse Transfer'}}</div>
        </div>


      </div>
    </div>
  </div>

  <app-bulk-add *ngIf="purchase.bulkAdd" [purchase]="purchase" [categories]="availableCategories" (closed)="bulkAddClosed($event)"></app-bulk-add>

  <!-- OFFLINE — unmissable, blocks the whole transfers screen. Scans while
       this shows are rejected and counted, never silently dropped. -->
  <div *ngIf="!connectivityService.isOnline() && !cacheMode()" class="offline-overlay no-print">
    <div class="offline-box">
      <svg class="offline-icon" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/></svg>
      <div class="offline-title">OFFLINE</div>
      <div class="offline-msg">Scans are NOT being recorded</div>
      <div *ngIf="blockedScanCount > 0" class="offline-blocked">{{blockedScanCount}} scan{{blockedScanCount === 1 ? '' : 's'}} blocked since disconnect</div>
      <div class="offline-reconnect">
        <svg class="processing" width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1639 1056q0 5-1 7-64 268-268 434.5t-478 166.5q-146 0-282.5-55t-243.5-157l-129 129q-19 19-45 19t-45-19-19-45v-448q0-26 19-45t45-19h448q26 0 45 19t19 45-19 45l-137 137q71 66 161 102t187 36q134 0 250-65t186-179q11-17 53-117 8-23 30-23h192q13 0 22.5 9.5t9.5 22.5zm25-800v448q0 26-19 45t-45 19h-448q-26 0-45-19t-19-45 19-45l138-138q-148-137-349-137-134 0-250 65t-186 179q-11 17-53 117-8 23-30 23h-199q-13 0-22.5-9.5t-9.5-22.5v-7q65-268 270-434.5t480-166.5q146 0 284 55.5t245 156.5l130-129q19-19 45-19t45 19 19 45z"/></svg>
        Reconnecting&hellip;
      </div>
    </div>
  </div>

  <div *ngIf="purchase && purchase.loading" class="loader">
    <svg class="processing" width="1792" height="1792" viewBox="0 0 1792 1792" xmlns="http://www.w3.org/2000/svg"><path d="M1639 1056q0 5-1 7-64 268-268 434.5t-478 166.5q-146 0-282.5-55t-243.5-157l-129 129q-19 19-45 19t-45-19-19-45v-448q0-26 19-45t45-19h448q26 0 45 19t19 45-19 45l-137 137q71 66 161 102t187 36q134 0 250-65t186-179q11-17 53-117 8-23 30-23h192q13 0 22.5 9.5t9.5 22.5zm25-800v448q0 26-19 45t-45 19h-448q-26 0-45-19t-19-45 19-45l138-138q-148-137-349-137-134 0-250 65t-186 179q-11 17-53 117-8 23-30 23h-199q-13 0-22.5-9.5t-9.5-22.5v-7q65-268 270-434.5t480-166.5q146 0 284 55.5t245 156.5l130-129q19-19 45-19t45 19 19 45z"/></svg>
  </div>

</ng-container>
<app-support *ngIf="supportActive" class="support-column"></app-support>
<app-settings *ngIf="settingsActive"></app-settings>
